/**
 * Wild Workouts trainer
 * TODO
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The HourUpdate model module.
 * @module model/HourUpdate
 * @version 1.0.0
 */
class HourUpdate {
    /**
     * Constructs a new <code>HourUpdate</code>.
     * @alias module:model/HourUpdate
     * @param hours {Array.<Date>} 
     */
    constructor(hours) { 
        
        HourUpdate.initialize(this, hours);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, hours) { 
        obj['hours'] = hours;
    }

    /**
     * Constructs a <code>HourUpdate</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/HourUpdate} obj Optional instance to populate.
     * @return {module:model/HourUpdate} The populated <code>HourUpdate</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new HourUpdate();

            if (data.hasOwnProperty('hours')) {
                obj['hours'] = ApiClient.convertToType(data['hours'], ['Date']);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<Date>} hours
 */
HourUpdate.prototype['hours'] = undefined;






export default HourUpdate;

